export const BASE_URL = import.meta.env.VITE_APP_API;
export const WEB_URL = import.meta.env.VITE_APP_WEB_URL;